<template lang="pug">
div
  template(v-if="data.length > 0")
    el-badge(:value="data.length" class="item")
      el-button.push-right(
        type="warning"
        icon="el-icon-download"
        @click="drawer = true"
      ) Procesos en cola
  template(v-else)
    el-button.push-right(
      type="warning"
      icon="el-icon-download"
      @click="drawer = true"
    ) Procesos en cola
  el-drawer(
    title="Procesos en cola"
    :visible.sync="drawer"
    :direction="direction"
  )
    template(v-for="item in data")
      el-card.__download-queue
        div(slot="header")
          el-row.card_header(justify="space-between")
            el-col(:span="19") {{ item.origin }}
            el-col(:span="4" style="display: flex; justify-content: flex-end;")
              el-tag.status(
                :type="statusTagColor(item.status)"
                size="small"
              ) {{ statusTagName(item.status) }}
        div.card_body
          el-row
            el-col(:span="18")
              el-descriptions(:column="1")
                template(v-if="item.file !== null")
                  el-descriptions-item(label="Archivo importado") {{ item.file }}
                template(v-if="item.conciliable !== null")
                  el-descriptions-item(label="Operador") {{ item.conciliable }}
                el-descriptions-item(label="Fecha de solicitud")
                  el-tag(type="info" size="small") {{ item.date }}
                el-descriptions-item(label="Responsable") {{ item.responsible }}
            el-col(:span="6")
              el-progress(type="circle" :width="80" :percentage="item.percentage"
                          :color="item.colors", :status="getProgressStatus(item)")
          el-row(v-if="item.status === 'in_progress'")
            div(class="card-loader")
              i.el-icon-loading
              template(v-if="item.file !== null")
                span Se está importando el archivo, por favor espere
              template(v-else-if="item.origin.includes('conciliación')")
                span Se está actualizando la conciliación, por favor espere
              template(v-else-if="item.origin.includes('descuento')")
                span Se está procesando el descuento, por favor espere
              template(v-else-if="item.origin.includes('transferencia')")
                span Se está procesando la transferencia, por favor espere
              template(v-else)
                span Se está generando el reporte, por favor espere
</template>

<script>
import store from '@/store';
import handleDownload from '@/utils/handleDownload';

export default {
  name: 'DownloadQueue',
  data() {
    return {
      drawer: false,
      direction: 'rtl',
      data: [],
      successColors: [
        { color: '#ff5353', percentage: 1 },
        { color: '#e6a23c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#1989fa', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#5cb87a', percentage: 100 },
      ],
      errorColors: [
        { color: '#ff4f4f', percentage: 100 },
      ],
    };
  },
  methods: {
    statusTagColor(status) {
      let color = '';
      switch (status) {
        case 'in_progress':
          color = 'default';
          break;
        case 'completed':
          color = 'success';
          break;
        case 'error':
          color = 'danger';
          break;
        default:
          color = 'info';
          break;
      }
      return color;
    },
    statusTagName(status) {
      let name = '';
      switch (status) {
        case 'in_progress':
          name = 'En progreso';
          break;
        case 'completed':
          name = 'Completado';
          break;
        case 'error':
          name = 'Error';
          break;
        default:
          name = 'Info';
          break;
      }
      return name;
    },
    removeCompletedItem(origin, responsible, date) {
      setTimeout(() => {
        const index = this.data.findIndex(
          (item) => item.origin === origin
            && item.responsible === responsible
            && item.date === date,
        );
        if (index !== -1) {
          this.data.splice(index, 1);
          this.storeQueueData();
          this.removeStoredItem(origin, responsible, date);
        }
      }, 15000);
    },
    downloadCsv(response) {
      const blob = new Blob([response.file_content], { type: 'text/csv' });
      const simulatedResponse = {
        blob: async () => blob,
        headers: {
          get: (header) => {
            if (header === 'content-disposition') {
              return `attachment; filename="${response.filename}.csv"`;
            }
            return null;
          },
        },
      };
      handleDownload(simulatedResponse);
    },
    downloadXlsx(response) {
      const binary = atob(response.file_content);
      const array = new Uint8Array(binary.length);
      Array.from(binary).forEach((char, index) => {
        array[index] = char.charCodeAt(0);
      });

      const blob = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      const simulatedResponse = {
        blob: async () => blob,
        headers: {
          get: (header) => {
            if (header === 'content-disposition') {
              return `attachment; filename="${response.filename}"`;
            }
            return null;
          },
        },
      };

      handleDownload(simulatedResponse);
    },
    downloadTxt(response) {
      const blob = new Blob([response.file_content], { type: 'text/plain' });

      const simulatedResponse = {
        blob: async () => blob,
        headers: {
          get: (header) => {
            if (header === 'content-disposition') {
              return `attachment; filename="${response.filename}.txt"`;
            }
            return null;
          },
        },
      };

      handleDownload(simulatedResponse);
    },
    getProgressStatus(item) {
      if (item.status === 'completed') return 'success';
      if (item.status === 'error') return 'exception';
      return null;
    },
    storeQueueData() {
      localStorage.setItem('downloadQueueData', JSON.stringify(this.data));
    },
    loadStoredQueueData() {
      const stored = localStorage.getItem('downloadQueueData');
      if (stored) { this.data = JSON.parse(stored); }
    },
    removeStoredItem(origin, responsible, date) {
      const stored = localStorage.getItem('downloadQueueData');
      if (!stored) return;

      const parsedStore = JSON.parse(stored);
      const index = parsedStore.findIndex(
        (item) => item.origin === origin && item.responsible === responsible && item.date === date,
      );
      if (index !== -1) {
        parsedStore.splice(index, 1);
        localStorage.setItem('downloadQueueData', JSON.stringify(parsedStore));
      }
    },
    cleanObsoleteItems() {
      this.data.forEach((item) => {
        if (item.status === 'completed' || item.status === 'error') {
          this.removeCompletedItem(item.origin, item.responsible, item.date);
        }
      });
    },
  },
  channels: {
    GeneralChannel: {
      connected() { },
      received(data) {
        const index = this.data.findIndex(
          (item) => item.origin === data.origin && item.responsible === data.email
          && item.date === data.date,
        );

        if (index !== -1) {
          this.$set(this.data, index, {
            ...this.data[index],
            status: data.status,
            date: data.date,
            colors: data.status === 'error' ? this.errorColors : this.successColors,
            percentage: data.percentage,
          });
        } else {
          this.data.push({
            origin: data.origin,
            status: data.status,
            responsible: data.email,
            date: data.date,
            colors: data.status === 'error' ? this.errorColors : this.successColors,
            percentage: data.percentage,
            file: data.file,
            conciliable: data.conciliable,
          });
        }

        this.storeQueueData();

        if (data.status === 'completed') {
          this.removeCompletedItem(data.origin, data.email, data.date);
        }
        if (data.status === 'error') {
          this.removeCompletedItem(data.origin, data.email, data.date);
        }
      },
      rejected() { },
      disconnected() { },
    },
    PrivateChannel: {
      connected() { },
      received(data) {
        switch (data.file_type) {
          case 'csv': this.downloadCsv(data); break;
          case 'xlsx': this.downloadXlsx(data); break;
          case 'txt': this.downloadTxt(data); break;
          default:
            break;
        }
      },
      rejected() { },
      destroyed() { },
    },
  },
  mounted() {
    this.loadStoredQueueData();
    this.cleanObsoleteItems();

    const identifier = JSON.stringify({
      channel: 'PrivateChannel',
      user_email: store.state.user.email,
      origin: 'exports',
    });
    /* eslint-disable no-underscore-dangle */
    const subscription = this.$cable._cable.subscriptions.subscriptions
      .find((sub) => sub.identifier === identifier);
    /* eslint-enable no-underscore-dangle */

    if (subscription === undefined) {
      this.$cable.subscribe({ channel: 'GeneralChannel' });
      this.$cable.subscribe({ channel: 'PrivateChannel', user_email: store.state.user.email, origin: 'exports' });
    }
  },
};
</script>
<style scoped>
.push-right {
  margin-left: auto;
}
.card_header {
  display: flex;
  position: relative;
}
.el-card.__download-queue {
  margin: 12px;
}
.card_body {
  padding: 3px;
}
.status {
  margin-left: 5px;
}
.card-loader {
  text-align: center;
  margin-top: 10px;
}
.card-loader i {
  margin-right: 5px;
}
.card-loader span {
  font-size: 13px;
  color: rgb(110, 110, 110);
}
</style>
